import BaseService from "./base.service";
const service = new BaseService("/equipment_configs")
export default service;